import React from 'react';
import './Video.css';
import { FaGlobe } from 'react-icons/fa';
import video from "../../assets/videos/vedo4.mp4"
import { FaPhoneAlt } from 'react-icons/fa';
export default function Video() {
  return (
    <>
    <div className="hero-section">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="hero-overlay">
        <div className="icon-wrapper">
          <FaGlobe />
        </div>
        <h1 className="hero-title">tnzeem in Travel</h1>
        <h3 className="hero-subtitle">2025</h3>
        <button className="hero-btn">Discover the Trips</button>
      </div>

      <svg className="hero-curve" viewBox="0 0 100 50" preserveAspectRatio="none">
        <path d="M0,50 Q50,0 100,50" fill="transparent" stroke="white" strokeWidth="0.5" />
      </svg>
    </div>

      <div className="contact-banner container my-5">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white gap-3 px-4 py-3">
         <div className="d-flex align-items-center gap-2 flex-wrap">
      <FaPhoneAlt className="fs-4" />
      <a href="tel:920033239" className="text-white fw-bold text-decoration-none me-2">
        920033239
      </a>
      <span className="text-white">|</span>
      <a href="tel:920033239" className="text-white fw-bold text-decoration-none ms-2">
       920033239
      </a>
    </div>
    
    
            <div className="text-center flex-grow-1 fw-bold fs-5">
ابدا معنا بصنع  بسبتك اليوم            </div>
    
            <a href="/contact" className="btn btn-light btn-lg rounded-pill px-4 fw-bold contact-btn">
              تواصل معنا الآن
            </a>
          </div>
        </div>

    </>
  );
}